// Ideally, this function should live in the useOverlapInsightsAggregation hook
// and clean up the values directly for the return value. However, there are
// dozens of combinations of possible aggregations values (e.g. ['age'], ['age', 'gender'], ['aggregation', 'gender']) etc.
// and it might be quite dangerous to just clean up all the values undefined, null, N/A etc values directly there
// Therefore, this filter function is used directly in places where separate aggregations are used
const filterAggregationData = (value: string | undefined | null) =>
  ![undefined, null, "N/A", "O", ""].includes(value);

export default filterAggregationData;
